// @flow
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';
import { UserActionTypes } from 'app/common/redux/actions/user/actionTypes';

function getResource(id, pin_id) {
  // If a user follows/unfollows after clicking on a PP, we store the comopiste id of that
  // pin in the aux_data. This is attached to the USER_FOLLOW and USER_UNFOLLOW frontend_event logs
  return ResourceFactory.create('UserFollowResource', {
    user_id: id,
    aux_data: pin_id ? { pin_id } : undefined,
  });
}

export type UserFollow = {
  type: typeof UserActionTypes.USER_FOLLOW,
  payload: {
    id: string,
    value: boolean,
  },
};

function followUser(id: string, value: boolean): UserFollow {
  return {
    type: UserActionTypes.USER_FOLLOW,
    payload: {
      id,
      value,
    },
  };
}

export function follow(id: string, pin_id: ?string = null): Thunk<void> {
  return (dispatch) => {
    // on error, dispatch the unfollow action
    // todo (yen) - do we need to do more than this?
    getResource(id, pin_id)
      .callCreate()
      .catch(() => dispatch(followUser(id, false)));
    dispatch(followUser(id, true));
  };
}

export function unfollow(id: string, pin_id: ?string = null): Thunk<void> {
  return (dispatch) => {
    // on error, dispatch the follow action
    // todo (yen) - do we need to do more than this?
    getResource(id, pin_id)
      .callDelete()
      .catch(() => dispatch(followUser(id, true)));
    dispatch(followUser(id, false));
  };
}
